export default {
  error: {
    error_occured: "Ha habido un error",
    not_found: "No se ha encontrado el recurso solicitado.",
    reload_page: "Recargar la página",
    back: "Retroceder",
    message: {
      profile_load_failed:
        "No se ha podido cargar su perfil, es posible que se oculte parte de la información. Actualice la página.",
      not_found: "La página que ha solicitado no se encuentra.",
      unavailable: "Servicio no disponible",
      not_authorized_title: "Acceso prohibido",
      not_authorized: "No tiene los permisos necesarios",
      file_not_authorized: "No está autorizado a descargar un archivo",
      unauthenticated: "Debe autenticarse para acceder a esta página",
      usurpation_error:
        "Está suplantando una cuenta que no tiene acceso a este espacio, por favor deje de suplantar a este usuario",
      usurpation_restore_lost: "Ha salido de la cuenta suplantada. Vuelva a iniciar sesión para recuperar su sesión.",
      session_lost: "Su sesión ha expirado, vuelva a iniciar sesión",
    },
    go_back_to_home: "Volver al principio",
    support_message:
      "Se ha producido un error durante la operación que ha intentado realizar. Nuestros equipos están al tanto y trabajando para resolverlo. Gracias por su comprensión.",
    login_attempts:
      "Te quedan {attempts} intentos. Si superas ese límite, tu acceso quedará suspendido durante 5 minutos por motivos de seguridad.",
    login_blocked:
      "Tu cuenta ha sido bloqueada temporalmente tras varios intentos fallidos. Espera 5 minutos antes de volver a intentarlo.",
    sso_user_not_found: "Ninguna cuenta Studea corresponde a este usuario. Póngase en contacto con su administrador.",
    sso_link_expired: "Su enlace de conexión ya no es válido. Vuelva a conectarse desde su espacio habitual.",
  },
  warning: {
    title: "Attention : ",
  },
};
